/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolMagicButtonIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-magic-button"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9.32 19.23L6.58 13.18L0.53 10.43L6.58 7.67L9.32 1.63L12.07 7.67L18.13 10.43L12.07 13.18ZM19.07 22.38L17.7 19.35L14.68 17.98L17.7 16.6L19.07 13.57L20.45 16.6L23.48 17.98L20.45 19.35Z" fill={color} />
    </svg>
  );
}
